export const clerkLocalization = {
    locale: 'pl-PL',
    formFieldLabel__password: 'Hasło',
    formFieldLabel__currentPassword: 'Obecne hasło',
    formFieldLabel__newPassword: 'Nowe hasło',
    formFieldLabel__confirmPassword: 'Powtórz hasło',
    formFieldLabel__signOutOfOtherSessions: 'Wyloguj mnie z pozostałych urządzeń',
    formFieldInputPlaceholder__password: 'Wpisz hasło',
    formFieldError__notMatchingPasswords: 'Hasła muszą być takie same.',
    formFieldError__matchingPasswords: 'Hasła są takie same.',
    formButtonPrimary: 'Dalej',
    formButtonPrimary__continue: 'Dalej',
    formButtonPrimary__finish: 'Zakończ',
    taskResetPassword: {
        title: 'Ustaw nowe hasło',
        subtitle: 'Zanim przejdziesz dalej, ustaw nowe hasło do konta.',
        signOut: {
            actionText: 'Jesteś zalogowany jako {{identifier}}.',
            actionLink: 'Wyloguj się',
        },
        formButtonPrimary: 'Zapisz nowe hasło',
    },
    taskSetupMfa: {
        badge: 'Wymagane',
        start: {
            title: 'Włącz dodatkowe zabezpieczenie',
            subtitle: 'Skonfiguruj dodatkową metodę potwierdzania logowania.',
        },
    },
}
